module.exports = __webpack_public_path__ + "img/key 2.be0c7811.png";